import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { registerExpandableChangePasswordFormResourceBundleDe } from 'record-it-components/form/ExpandableChangePasswordForm/ExpandableChangePasswordForm.resourceBundle.de';
import { registerExpandableChangePasswordFormResourceBundleEn } from 'record-it-components/form/ExpandableChangePasswordForm/ExpandableChangePasswordForm.resourceBundle.en';
import { registerLoginFormResourceBundleDe } from 'record-it-components/form/LoginForm/LoginForm.resourceBundle.de';
import { registerLoginFormResourceBundleEn } from 'record-it-components/form/LoginForm/LoginForm.resourceBundle.en';
import { registerTimeClockPickerModalResourceBundleDe } from 'record-it-components/dateTime/TimeClockPickerModal/TimeClockPickerModal.resourceBundle.de';
import { registerTimeClockPickerModalResourceBundleEn } from 'record-it-components/dateTime/TimeClockPickerModal/TimeClockPickerModal.resourceBundle.en';
import { registerItemsToSynchronizeListResourceBundleDe } from 'record-it-components/synchronization/ItemsToSynchronizeList/ItemsToSynchronizeList.resourceBundle.de';
import { registerItemsToSynchronizeListResourceBundleEn } from 'record-it-components/synchronization/ItemsToSynchronizeList/ItemsToSynchronizeList.resourceBundle.en';
import { registerItemsToSynchronizeListItemResourceBundleDe } from 'record-it-components/synchronization/ItemsToSynchronizeListItem/ItemsToSynchronizeListItem.resourceBundle.de';
import { registerItemsToSynchronizeListItemResourceBundleEn } from 'record-it-components/synchronization/ItemsToSynchronizeListItem/ItemsToSynchronizeListItem.resourceBundle.en';
import { registerNavigationSidebarResourceBundleDe } from 'record-it-components/pageLayout/NavigationSidebar/NavigationSidebar.resourceBundle.de';
import { registerNavigationSidebarResourceBundleEn } from 'record-it-components/pageLayout/NavigationSidebar/NavigationSidebar.resourceBundle.en';
import { registerForgotPasswordFormResourceBundleDe } from 'record-it-components/form/ForgotPasswordForm/ForgotPasswordForm.resourceBundle.de';
import { registerForgotPasswordFormResourceBundleEn } from 'record-it-components/form/ForgotPasswordForm/ForgotPasswordForm.resourceBundle.en';
import { registerResetPasswordFormResourceBundleDe } from 'record-it-components/form/ResetPasswordForm/ResetPasswordForm.resourceBundle.de';
import { registerResetPasswordFormResourceBundleEn } from 'record-it-components/form/ResetPasswordForm/ResetPasswordForm.resourceBundle.en';
import { registerGlobalConfirmDeleteDialogProviderProviderResourceBundleDe } from 'record-it-components/modal/GlobalConfirmDeleteDialogProvider/GlobalConfirmDeleteDialogProvider.resourceBundle.de';
import { registerGlobalConfirmDeleteDialogProviderProviderResourceBundleEn } from 'record-it-components/modal/GlobalConfirmDeleteDialogProvider/GlobalConfirmDeleteDialogProvider.resourceBundle.en';
import { registerLocationContentContainerResourceBundleDe } from 'record-it-components/location/LocationContentContainer/LocationContentContainer.resourceBundle.de';
import { registerLocationContentContainerResourceBundleEn } from 'record-it-components/location/LocationContentContainer/LocationContentContainer.resourceBundle.en';
import { registerSelectLocationDialogResourceBundleDe } from 'record-it-components/location/SelectLocationDialog/SelectLocationDialog.resourceBundle.de';
import { registerSelectLocationDialogResourceBundleEn } from 'record-it-components/location/SelectLocationDialog/SelectLocationDialog.resourceBundle.en';
import { registerLocationInputResourceBundleDe } from 'record-it-components/input/LocationInput/LocationInput.resourceBundle.de';
import { registerLocationInputResourceBundleEn } from 'record-it-components/input/LocationInput/LocationInput.resourceBundle.en';
import { registerPasswordRulesBoxResourceBundleDe } from 'record-it-components/misc/PasswordRulesBox/PasswordRulesBox.resourceBundle.de';
import { registerPasswordRulesBoxResourceBundleEn } from 'record-it-components/misc/PasswordRulesBox/PasswordRulesBox.resourceBundle.en';
import { de } from '../translation/de';

export function initI18n(): Promise<void> {
  return i18n
    .use(initReactI18next)
    .init({
      lng: 'de',
      fallbackLng: 'de',
      defaultNS: 'time',
      ns: ['record-it-components', 'time'],
      react: {
        bindI18n: 'languageChanged',
        bindI18nStore: 'added',
        useSuspense: false
      }
    })
    .then(() => {
      i18n.addResourceBundle('de', 'time', de);

      registerExpandableChangePasswordFormResourceBundleDe(i18n);
      registerExpandableChangePasswordFormResourceBundleEn(i18n);

      registerLoginFormResourceBundleDe(i18n);
      registerLoginFormResourceBundleEn(i18n);

      registerForgotPasswordFormResourceBundleDe(i18n);
      registerForgotPasswordFormResourceBundleEn(i18n);

      registerResetPasswordFormResourceBundleDe(i18n);
      registerResetPasswordFormResourceBundleEn(i18n);

      registerTimeClockPickerModalResourceBundleDe(i18n);
      registerTimeClockPickerModalResourceBundleEn(i18n);

      registerGlobalConfirmDeleteDialogProviderProviderResourceBundleDe(i18n);
      registerGlobalConfirmDeleteDialogProviderProviderResourceBundleEn(i18n);

      registerItemsToSynchronizeListItemResourceBundleDe(i18n);
      registerItemsToSynchronizeListItemResourceBundleEn(i18n);

      registerItemsToSynchronizeListResourceBundleDe(i18n);
      registerItemsToSynchronizeListResourceBundleEn(i18n);

      registerNavigationSidebarResourceBundleDe(i18n);
      registerNavigationSidebarResourceBundleEn(i18n);

      registerLocationContentContainerResourceBundleDe(i18n);
      registerLocationContentContainerResourceBundleEn(i18n);

      registerSelectLocationDialogResourceBundleDe(i18n);
      registerSelectLocationDialogResourceBundleEn(i18n);

      registerLocationInputResourceBundleDe(i18n);
      registerLocationInputResourceBundleEn(i18n);

      registerPasswordRulesBoxResourceBundleDe(i18n);
      registerPasswordRulesBoxResourceBundleEn(i18n);
    });
}
